const Cancel = () => (
    <div>
      <h1>❌ Payment Canceled</h1>
      <p>No worries! You can try again anytime.</p>
      <a href="/subscription">Go back to Subscriptions & Pricing Page</a>
    </div>
  );
  export default Cancel;
  